var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-inline pa-2 deep-purple accent-4 white--text"},[_vm._v("d-inline")]),_c('div',{staticClass:"d-inline pa-2 black white--text"},[_vm._v("d-inline")])])
}]

export { render, staticRenderFns }